import { createAsyncThunk } from "@reduxjs/toolkit";
import { getList } from "./api";

export const ActionType = Object.freeze({
    base: "@@Monitoring/Action/Admin/List",
    getList: "getList",
});

export const getListAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.getList}`,
    async(_, { rejectWithValue }) => {
        const response = await getList();

        if (response.error === undefined) {
            // API処理結果正常の場合
            return { ...response };
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);
